import SectionHeading from '../HomePage/SectionHeading'
import PodcastsWithPagination from '../Podcasts/PodcastsWithPagination'

const RelatedPodcasts = ({ podcasts }) => {
    return (
        <div className="bg-gray-50 px-4 py-10">
            <div className="container mx-auto py-8">
                <SectionHeading textAlignment="text-left">
                    <p className="olm-gradient-text">More from this</p>
                </SectionHeading>
                <PodcastsWithPagination
                    pagination={false}
                    podcasts={podcasts}
                />
            </div>
        </div>
    )
}

export default RelatedPodcasts
